<div class="add-user">
  <h2>{{addEditPageTitle}}</h2>

  <!-- <h3>User details</h3> -->
  <form #userForm="ngForm" (submit)="userForm.form.valid && onSubmitUserForm()">

    <div class="form-messages" id="userFormMessages" tabindex="-1">
      <div class="label info red" *ngIf="usernameField.touched && !isUsernameDomainValid()">
        {{usernameDomainErrorMessage()}}
      </div>

      <div class="label info red" *ngIf="submitAttempted && !userForm.form.valid">
        Not all required fields have been completed.
      </div>

      <div class="label info red" *ngIf="user.id === 1">
        <p>Locked down administrator details can not be changed.</p>
      </div>

      <div class="label info red" *ngIf="errorStatus">
        {{errorMessage}}
      </div>

      <div class="label info green" *ngIf="successMessage">
        {{successMessage}}
      </div>
    </div>

      <!-- <label class="form-group right-align">
          <span>Test Field</span>
          <span class="input-layer">
            <input aria-label=""  class="form-control" id="testfield" name="testfield" placeholder="test field"
                   type="text" required [(ngModel)]="user.changeDecision" #spy>
          </span>
          <br>{{user.changeDecision}}
          <br>{{spy.className}}
        </label> -->

    <label class="form-group">
      <span>title</span>
      <span class="select-layer">
        <select 
          class="app-select" 
          name="title" 
          id="title" 
          required
          [(ngModel)]="user.title">
          <option>Mr</option>
          <option>Miss</option>
          <option>Mrs</option>
          <option>Ms</option>
          <option>Mx</option>
          <option>M</option>
          <option>Dr</option>
        </select>
      </span>
    </label>

    <label class="form-group right-align">
      <span>first name</span>
      <span class="input-layer">
        <input aria-label=""  
          class="app-input" 
          name="firstName" 
          id="firstName"
          required
          placeholder="John"
          type="text" 
          [(ngModel)]="user.firstName">
      </span>
    </label>

    <label class="form-group">
      <span>last name</span>
      <span class="input-layer">
        <input aria-label=""  
          class="app-input" 
          name="lastName" 
          id="lastName"
          required
          placeholder="Smith"
          type="text" 
          [(ngModel)]="user.lastName">
      </span>
    </label>

    <label class="form-group right-align">
      <span>username</span>
      <span class="input-layer">
        <input aria-label=""
          class="app-input"
          name="username"
          id="username"
          required
          placeholder="{{clientDomain}}"
          type="email"
          [(ngModel)]="user.username"
          #usernameField="ngModel">
      </span>
    </label>

    <label class="form-group">
      <span>job title</span>
      <span class="input-layer">
        <input aria-label=""  
          class="app-input" 
          name="jobTitle" 
          id="jobTitle"
          placeholder="Manager"
          type="text" 
          [(ngModel)]="user.jobTitle">
      </span>
    </label>

    <label class="form-group right-align">
      <span>interface user reference</span>
      <span class="input-layer">
        <input aria-label=""  
          class="app-input" 
          name="externalId" 
          id="externalId"
          placeholder="Interfaced customers only"
          type="text" 
          [(ngModel)]="user.externalUserId">
      </span>
    </label>

    <!-- <label class="form-group">
      <span>Printer</span>
      <span class="select-layer">
        <select class="app-select" name="printer"
                [(ngModel)]="user.printer">
          <option value="Dummy printer" selected>
            Dummy printer
          </option>
        </select>
      </span>
    </label> -->

    <!-- <label class="form-group">
      <span>Login email address</span>
      <span class="input-layer">
        <input aria-label=""  
          class="app-input" 
          name="emailAddress" 
          id="emailAddress"
          required
          placeholder= "{{clientDomain}}"
          type="email" 
          [(ngModel)]="user.emailAddress">
        [disabled]="isEditPage"
      </span>
    </label> -->

    <label class="form-group">
        <span>contact email address</span>
        <span class="input-layer">
          <input aria-label=""  
            class="app-input" 
            name="contactEmailAddress" 
            id="contactEmailAddress"
            required
            placeholder= "user@domain.com"
            type="email" 
            [(ngModel)]="user.emailAddress">
          <!--[disabled]="isEditPage"-->
        </span>
      </label>

    <label class="form-group right-align">
      <span>daily letter target</span>
      <span class="input-layer">
        <input aria-label=""  
          class="app-input" 
          name="letter-target" 
          placeholder="Daily letter target"
          type="number" 
          min="0" 
          [(ngModel)]="userSettings.dailyLetterTarget">
      </span>
    </label>

    <label class="form-group full-width">
      <span>signature</span>
      <div class="signatures">
        <span class="signature" *ngFor="let signature of signatures"
              [ngClass]="{'selected': user.signatureId === signature.id}"
              (click)="user.signatureId = signature.id">
          <img src="{{signature.image}}" width="150" />
        </span>
      </div>
    </label>

    <!-- <h3>Job specifications</h3> -->

    <label class="form-group">
      <span>role</span>
      <span class="select-layer" [ngClass]="{'disabled': user.id === 1}">
        <select class="app-select" name="role" [disabled]="user.id === 1"
                [(ngModel)]="user.roleId" (change)="onChangeRole($event.target.value)">
          <option value="1">User</option>
          <option value="2">Team leader</option>
          <option value="3">Manager</option>
        </select>
      </span>
    </label>

    <label class="form-group right-align">
      <span>team leader</span>
      <span class="select-layer" [ngClass]="{'disabled': user.roleId.toString() === '2'
            || user.roleId.toString() === '3' }">
        <select 
          class="app-select" 
          name="teamLeader" 
          id="teamLeader"
          required
          [(ngModel)]="user.teamLeader"
          [disabled]="user.roleId.toString() === '2' || user.roleId.toString() === '3'">
          <option value="null" disabled selected hidden>please select</option>
          <option value="0" selected *ngIf="user.roleId.toString() !== '1'">None</option>
          <option [value]="teamLeader.id" *ngFor="let teamLeader of teamLeaders">
            {{teamLeader.firstName}} {{teamLeader.lastName}} 
          </option>
        </select>
      </span>
    </label>

    <label class="form-group">
      <span>admin access</span>
      <span class="select-layer" [ngClass]="{'disabled': user.roleId.toString() === '3' }">
        <select 
          class="app-select" 
          name="adminAccess" 
          id="adminAccess"
          required
          [disabled]="user.roleId.toString() === '3'"
          [(ngModel)]="user.adminAccess">
          <option value="null" disabled selected hidden>please select</option>
          <option value="true">yes</option>
          <option value="false">no</option>
        </select>
      </span>
    </label>

    <label class="form-group right-align">
      <span>reports access</span>
      <span class="select-layer" [ngClass]="{'disabled': user.roleId.toString() === '3' }">
        <select 
          class="app-select" 
          name="reportsAccess" 
          id="resportsAccess"
          required
          [disabled]="user.roleId.toString() === '3'"
          [(ngModel)]="user.reportsAccess">
          <option value="null" disabled selected hidden>please select</option>
          <option value="true">yes</option>
          <option value="false">no</option>
        </select>
      </span>
    </label>

    <label class="form-group">
      <span>change decision</span>
      <span class="select-layer" [ngClass]="{'disabled': user.roleId.toString() === '3' }">
        <select 
          class="app-select" 
          name="changeDecision" 
          id="changeDecision"
          required
          [disabled]="user.roleId.toString() === '3'"
          [(ngModel)]="user.changeDecision">
          <option value="null" disabled selected hidden>please select</option>
          <option value="1">yes</option>
          <option value="0">no</option>
        </select>
      </span>
    </label>

    <div class="form-group right-align account-actions" *ngIf="isEditPage && (!user.isActivated || user.isAccountLocked)">
      <span>account action</span>
      <div class="account-action-layer">
        <!-- A locked account is only shown once activated - can't lock an
             account that's never been activated, so these two never both
             show even if the data somehow ended up in that state. -->
        <div class="account-action" *ngIf="user.isAccountLocked && user.isActivated">
          <span class="status-badge red">account locked</span>
          <button type="button" class="app-submit secondary small" (click)="openUnlockDialog()">unlock account</button>
        </div>

        <div class="account-action" *ngIf="!user.isActivated">
          <span class="status-badge red">not yet activated</span>
          <button type="button" class="app-submit secondary small" (click)="openResendDialog()">resend activation email</button>
        </div>
      </div>
    </div>

    <kendo-dialog *ngIf="unlockDialogOpen" (close)="closeUnlockDialog()">
      <kendo-dialog-titlebar>
        <div style="font-size: 18px; line-height: 1.3em;">
          <span class="k-icon k-i-warning k-icon-md"></span> unlock account?
        </div>
      </kendo-dialog-titlebar>
      <p style="margin: 30px; text-align: center;">
        Are you sure you want to unlock this account?
      </p>
      <kendo-dialog-actions>
        <button kendoButton class="kendo-dialog-button" (click)="closeUnlockDialog()" role="button">No</button>
        <button kendoButton class="kendo-dialog-button" (click)="confirmUnlockAccount()">Yes</button>
      </kendo-dialog-actions>
    </kendo-dialog>

    <kendo-dialog *ngIf="resendDialogOpen" (close)="closeResendDialog()">
      <kendo-dialog-titlebar>
        <div style="font-size: 18px; line-height: 1.3em;">
          <span class="k-icon k-i-warning k-icon-md"></span> resend activation email?
        </div>
      </kendo-dialog-titlebar>
      <p style="margin: 30px; text-align: center;">
        Are you sure you want to resend the activation email? The previous activation email's link will stop working.
      </p>
      <kendo-dialog-actions>
        <button kendoButton class="kendo-dialog-button" (click)="closeResendDialog()" role="button">No</button>
        <button kendoButton class="kendo-dialog-button" (click)="confirmResendActivationEmail()">Yes</button>
      </kendo-dialog-actions>
    </kendo-dialog>

    <!-- <h3>Password details</h3>

    <label class="form-group">
      <span>Password*</span>
      <span class="input-layer">
        <input aria-label=""  class="app-input" name="password"
               type="password" [(ngModel)]="user.password" [required]="requirePassword">
      </span>
    </label>

    <label class="form-group right-align">
      <span>Confirm*</span>
      <span class="input-layer">
        <input aria-label=""  class="app-input" name="confirm"
               type="password" [(ngModel)]="user.confirmPassword" [required]="requirePassword">
      </span>
    </label>

    <div class="label info red no-margin-top" [innerHTML]="passwordValidationError"
         *ngIf="!isPasswordValid() && passwordValidationError !== ''"></div>
    <div class="label info red no-margin-top" *ngIf="isPasswordValid() && passwordValidationError !== ''
         && !isPasswordConfirmed() && user.password !== ''">
      Passwords do not match!
    </div>
    <div class="label info green no-margin-top" *ngIf="isPasswordValid() && user.password !== ''
         && isPasswordConfirmed()">
      Great, passwords match!
    </div> -->



    <span class="submit-layer">
      <input aria-label=""  type="submit" class="app-submit" value="Save" [disabled]="user.id === 1 || isSaving"
             (click)="onSaveClick()" />
    </span>

  </form>

</div>
